import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import LinearProgress from "@material-ui/core/LinearProgress";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import IconExchange19 from "../../../assets/images/IconExchange19.png";
import flag8 from "../../../assets/images/flag8.png";
import flag_bd4 from "../../../assets/images/flag_bd4.png";
import flag_usa4 from "../../../assets/images/flag_usa4.png";
import { TransferContext } from "../../../context/TransferContext";
import { AuthContext } from "../../../context/AuthContext";
import RefreshToken from "../../../components/RefreshToken";

const useStyles = makeStyles((theme) => ({
  marginBottomStyle: {
    marginBottom: "10px",
  },
  marginTopStyle: {
    marginTop: "20px",
  },

  inputStyle: {
    borderRadius: "8px",
  },
  inputStyle2: {
    borderRadius: "8px",
    // "& .MuiInputBase-input": {
    //   color: "#A2A2A2",
    // },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      fontSize: "14px",
      padding: 13,
      // border:'1px solid red',
      // borderRadius:'8px'
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
  },
  textField: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 13,
    },
  },

  selectItemStyle: {
    fontWeight: 600,
  },
  muteColor: {
    color: "#19181666",
  },
  mainGridStyle: {
    border: "1px solid #ddd",
    // padding: "30px",
    borderRadius: "10px",
  },
  mainLeftGridStyle: {
    padding: "30px 60px 30px 30px",
  },
  mainRightGridStyle: {
    background: "#FFF8E5",
    padding: "30px 30px 30px 60px",
  },
  rightAlign: {
    textAlign: "right",
  },
  greenColor: {
    color: "#35B522",
  },
  redColor: {
    color: "red",
  },
  mainTopStyle: {
    position: "relative",
  },
  mainImageStyle: {
    position: "absolute",
    left: "calc(50% - 41px)",
    top: "15%",
  },
  inputFontSyle: {
    "& .MuiInputBase-input": {
      fontSize: "40px",
    },
  },

  inputRoot: {
    "& .MuiOutlinedInput-input": {
      // color: "green",
    },
    "& .MuiInputLabel-root": {
      // color: "green",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "#eee",
      // backgroundColor: "#eee",
      color: "#333",
    },
    "&:hover .MuiOutlinedInput-input": {
      // color: "red",
    },
    "&:hover .MuiInputLabel-root": {
      // color: "red",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "red",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      // color: "purple",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      // color: "purple",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      // borderColor: "purple",
    },
  },
  flag: {
    marginRight: 10,
    position: "relative",
    width: 35,
    top: 6,
  },
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "rgba(0,0,0,0)",
      borderWidth: 0,
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "#fff",
    },

    padding: "5px",
    height: 45,
    borderRadius: 8,
    fontSize: "32px",
    paddingRight: 0,
  },
  formControlStyle: {
    width: "90%",
    float: "right",
  },
}));
const TransferAmount = () => {
  const classes = useStyles();
  const { transfer, addToTransfer } = useContext(TransferContext);

  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [sendAmount, setSendAmount] = useState(
    transfer.amountToTransfer && parseInt(transfer.amountToTransfer)
  );
  const [receiptAmount, setReceiptAmount] = useState(
    transfer.amountToTransfer && parseInt(transfer.sendAmount)
  );
  const [rate, setRate] = useState(transfer.rate);

  const [payment, setpayment] = useState(10);
  const [charge, setCharge] = useState("$ 0");

  const [From, setFrom] = useState(
    transfer.fromCountry && transfer.fromCountry.currency
  );
  const [To, setTo] = useState(
    transfer.toCountry && transfer.toCountry.currency
  );
  const [FromFlag, setFromFlag] = useState(
    transfer.fromCountry && transfer.fromCountry.flag
  );
  const [ToFlag, setToFlag] = useState(
    transfer.toCountry && transfer.toCountry.flag
  );

  const { login, glob_pay_agent_auth, logout } = useContext(AuthContext);

  const handleSendAmount = async (e) => {
    let money = parseInt(e.target.value);
    setSendAmount(money);
    addToTransfer({ amountToTransfer: money });
    addToTransfer({ sendAmount: money });
    setReceiptAmount(rate * money);
    addToTransfer({ amountReceivable: rate * money });
  };

  const handleSendCurrency = async (e) => {
    setLoading(true);
    setFrom(e.target.value);
    addToTransfer({ fromCurrency: e.target.value });

    let curr = e.target.value;
    let from = transfer.countries.filter((e) => e.currency === curr);
    console.log("from", curr, ...from);
    addToTransfer({ fromCountry: { ...from } });

    let token = await RefreshToken(glob_pay_agent_auth, logout, login);
    try {
      let amount = await axios({
        url: `/api/v1/private/currency/${e.target.value}/all`,
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("from res", amount.data.data.rates);
      let rate = amount.data.data.rates;
      let receipt = rate[To];
      setRate(receipt);
      setReceiptAmount(receipt * sendAmount);
      addToTransfer({ amountReceivable: receipt * sendAmount });

      console.log("tooo:", To, receipt * sendAmount);
      setRefresh(!refresh);
    } catch (error) {}
    setLoading(false);
  };

  const handleReceiveCurrency = async (e) => {
    setLoading(true);
    setTo(e.target.value);
    addToTransfer({ toCurrency: e.target.value });

    let curr = e.target.value;
    let to = transfer.countries.filter((e) => e.currency === curr);
    console.log("to", curr, ...to);
    addToTransfer({ toCountry: { ...to } });

    let token = await RefreshToken(glob_pay_agent_auth, logout, login);
    try {
      let amount = await axios({
        url: `/api/v1/private/currency/${From}/all`,
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("to res", amount.data.data.rates);
      let rate = amount.data.data.rates;
      let receipt = rate[e.target.value];
      setRate(receipt);
      setReceiptAmount(receipt * sendAmount);
      addToTransfer({ amountReceivable: receipt * sendAmount });

      console.log("tooo:", To, receipt * sendAmount);
      setRefresh(!refresh);
    } catch (error) {}
    setLoading(false);
  };

  useEffect(() => {
    console.log("to corr", transfer.toCountry && transfer.toCountry.currency);
  });

  return (
    <>
      {/* <Typography variant="h4" className={classes.marginBottomStyle}>
        Transfer Amount
      </Typography> */}
      <div className={classes.mainTopStyle}>
        <div className={classes.mainImageStyle}>
          <img src={IconExchange19} alt="" />
        </div>
        <div>
          {loading ? <LinearProgress /> : null}
          <Grid container className={classes.mainGridStyle}>
            <Grid item xs={6} className={classes.mainLeftGridStyle}>
              <Grid container alignItems="flex-end" spacing={1}>
                <Grid item xs={8}>
                  <Typography variant="body1">Amount to send</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" className={classes.muteColor}>
                    {transfer.fromCountry && transfer.fromCountry.name}
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <TextField
                    fullWidth
                    id="amount-send"
                    value={sendAmount}
                    onChange={handleSendAmount}
                    className={classes.inputFontSyle}
                    type="number"
                  />
                </Grid>
                <Grid item xs={5}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    className={classes.formControlStyle}
                  >
                    <TextField
                      className={classes.inputRoot}
                      value={From}
                      onChange={handleSendCurrency}
                      select
                      InputProps={{
                        className: classes.select,
                      }}
                    >
                      {transfer.countries &&
                        transfer.countries.map((e, index) => (
                          <MenuItem
                            key={index}
                            value={e.currency}
                            className={classes.selectItemStyle}
                          >
                            <img src={e.flag} alt="" className={classes.flag} />
                            {e.currency}
                          </MenuItem>
                        ))}
                    </TextField>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} className={classes.mainRightGridStyle}>
              <Grid container alignItems="flex-end" spacing={1}>
                <Grid item xs={8}>
                  <Typography variant="body1"> Recipient gets</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" className={classes.muteColor}>
                    {transfer.toCountry && transfer.toCountry.name}
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <TextField
                    fullWidth
                    id="recipient-gets"
                    value={receiptAmount.toFixed(2)}
                    // onChange={(e) => setReceiptAmount(e.target.value)}
                    className={classes.inputFontSyle}
                  />
                </Grid>
                <Grid item xs={5}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    className={classes.formControlStyle}
                  >
                    <TextField
                      className={classes.inputRoot}
                      value={To}
                      onChange={handleReceiveCurrency}
                      select
                      InputProps={{
                        className: classes.select,
                      }}
                    >
                      {transfer.countries &&
                        transfer.countries.map((e, index) => (
                          <MenuItem
                            key={index}
                            value={e.currency}
                            className={classes.selectItemStyle}
                          >
                            <img src={e.flag} alt="" className={classes.flag} />
                            {e.currency}
                          </MenuItem>
                        ))}
                    </TextField>
                  </FormControl>
                </Grid>
                <Grid item xs={12} className={classes.marginTopStyle}>
                  <Typography variant="body1">
                    1 {From} = {rate} {To}
                  </Typography>
                  <Typography variant="body2" className={classes.muteColor}>
                    *Rate may vary depending on the country policy
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
      <Grid
        container
        alignItems="center"
        className={classes.marginTopStyle}
        spacing={4}
      >
        <Grid item xs={9} className={classes.rightAlign}>
          <Typography variant="h6">Charge</Typography>
        </Grid>
        <Grid item xs={3} className={classes.rightAlign}>
          <Typography variant="h5" className={classes.redColor}>
            0.00 {From}
          </Typography>
        </Grid>

        <Grid item xs={9} className={classes.rightAlign}>
          <Typography variant="h6">Total Receivable</Typography>
        </Grid>
        <Grid item xs={3} className={classes.rightAlign}>
          <Typography variant="h5" className={classes.greenColor}>
            {receiptAmount.toFixed(2)} {To}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default TransferAmount;
